import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Tabs } from 'antd';
import { UserOutlined } from '@ant-design/icons';

import { RootState } from '../../../store/store';
import ContactInfoPage from './contactInfo/ContactInfoPage';
import AccessKeyStaff from './accessKey/AccessKeyStaff';
import Comments from '../Comments';
import PageTitle from '../../../components/page/PageTitle';
import {
    selectIsStaff,
    selectAccountMembershipNumber,
    selectHasStaffRole
} from '../../../store/slices/userSlice';
import { useAppSelector } from '../../../hooks/useStore';

const PersonalInfoTabs = () => {
    const isMCT = useAppSelector((state: RootState) => selectHasStaffRole(state, ['member-care', 'developer']));
    const navigate = useNavigate();
    const isStaff = useAppSelector(selectIsStaff);
    const activePersonId = useAppSelector(state => state.user.person)?.id;
    const accountMembershipNumber = useAppSelector(selectAccountMembershipNumber);

    React.useEffect(() => {
        if (accountMembershipNumber === null) {
            navigate('/member_change');
        }
    }, [navigate, accountMembershipNumber]);

    const tabItems = [
        { key: '1', tab: 'Contact Information', label: 'Contact Information', content: <ContactInfoPage /> },
        { key: '2', tab: 'Access Key', label: 'Access Key', content: isStaff && <AccessKeyStaff /> },
        { key: '3', tab: 'Comments', label: 'Comments', content: isMCT && activePersonId && <Comments commentableType="App\Models\Accounts\Person" commentableID={activePersonId} /> }
    ].filter(tab => tab.content);

    return (
        <>
            <PageTitle title="Personal Info" icon={<UserOutlined />} />
            <Tabs defaultActiveKey="1" items={tabItems.map(tab => ({ key: tab.key, tab: tab.tab, label: tab.label, children: tab.content }))} />
        </>
    );
}

export default PersonalInfoTabs;
